<template>
  <div>
    <!-- 发票信息概况 -->
    <div class="invoice">
      <!-- 当前发票信息概况： -->
      <div class="summaryOfCurrentInvoiceInformation">
        <h6>{{ $t("message.summaryOfCurrentInvoiceInformation") }}：</h6>
        <!-- 列表信息-->
        <div class="information">
          <div class="row">
            <!--件数  -->
            <div class="item">
              <div class="label">件数</div>
              <div class="value border-right" style="color: #333">
                {{ details.pcs }}
              </div>
            </div>
            <!-- 箱数 -->
            <div class="item">
              <div class="label">{{ $t("message.boxNum") }}</div>
              <div class="value">{{ details.boxCount }}</div>
            </div>
          </div>
          <div class="row">
            <!--发送方式  -->
            <div class="item">
              <div class="label">{{ $t("message.wayToSend") }}</div>
              <div class="value border-right">
                {{ $route.query.type }}
              </div>
            </div>
            <!-- 是否是fba  -->
            <div class="item">
              <div class="label">配送单号 </div>
              <div class="value">
                <router-link :to="'/porderDetail?porder_sn=' + details.customerRefNo" target="_blank" class="a-link"
                  style="color: #b4272d">{{ details.customerRefNo }}</router-link>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- 物流单号 -->
            <div class="item">
              <div class="label">{{ $t("message.logisticsSingleNumber") }}</div>
              <div class="value border-right">{{ details.orderNo }}</div>
            </div>
            <div class="item">
              <div class="label">毛重</div>
              <div class="value">{{ details.grossWeight }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 发件人信息： -->
    </div>
    <!-- 地址 -->
    <div class="address">
      <div class="information" style="margin-right: 40px">
        <div class="p">
          收件人信息：
          <el-button size="mini" type="primary" class="primary" @click="copyImporter">复制到进口商</el-button>
          <div class="btn fr" @click="isReceiver = !isReceiver">
            <el-button size="mini" type="primary" class="primary" v-if="!isReceiver">
              {{ $t("message.redact") }}
            </el-button>
            <el-button size="mini" type="primary" class="primary" v-else>
              {{ $t("message.complete") }}
            </el-button>
          </div>
        </div>
        <div class="list">
          <div class="row">
            <div class="item">
              <div class="label">会社：</div>
              <div class="value">
                <el-input size="small" v-model="details.consigneeCompany" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">收件人：</div>
              <div class="value">
                <el-input size="small" v-model="details.consigneeName" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">郵便：</div>
              <div class="value">
                <el-input size="small" v-model="details.consigneeZipcode" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">住所：</div>
              <div class="value">
                <el-input size="small" v-model="details.consigneeAddress" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">電話：</div>
              <div class="value">
                <el-input size="small" v-model="details.consigneeTel" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item">
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">收件人地址(英文)：</div>
              <div class="value">
                <el-input size="small" v-model="details.consigneeAddressEn" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item">
            </div>
          </div>
        </div>
      </div>
      <div class="information">
        <div class="p">
          进口商信息:
          <el-radio v-model="details.is_person" :label="1">个人进口商信息</el-radio>
          <el-radio v-model="details.is_person" :label="0"> 进口商信息</el-radio>
          <div class="btn fr" @click="isImporter = !isImporter">
            <el-button size="mini" type="primary" class="primary" v-if="!isImporter">
              {{ $t("message.redact") }}
            </el-button>
            <el-button size="mini" type="primary" class="primary" v-else>
              {{ $t("message.complete") }}
            </el-button>
          </div>
        </div>
        <div class="list">
          <div class="row">
            <div class="item">
              <div class="label">会社：</div>
              <div class="value">
                <el-input size="small" v-model="details.importerName" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">電話：</div>
              <div class="value">
                <el-input size="small" v-model="details.importerPhone" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">住所：</div>
              <div class="value">
                <el-input size="small" v-model="details.importerContact" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">法人番号：</div>
              <div class="value">
                <el-input size="small" v-model="details.importerOwnerName" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">郵便：</div>
              <div class="value">
                <el-input size="small" v-model="details.importerZipCode" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">银行口座：</div>
              <div class="value">
                <el-input size="small" v-model="details.importerBankInfo" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">进口商公司(英文)：</div>
              <div class="value">
                <el-input size="small" v-model="details.importerNameEn" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">进口商地址(英文)：</div>
              <div class="value">
                <el-input size="small" v-model="details.importerContactEn" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">通关编码：</div>
              <div class="value">
                <el-input size="small" v-model="details.importerPersonCode" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">邮箱：</div>
              <div class="value">
                <el-input size="small" v-model="details.consigneeEmail" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
    </div>
    <!-- 商品信息 -->
    <div class="commodity">
      <!-- 商品信息 -->
      <div class="information">
        {{ $t("message.commodityInformation") }}
        <div class="fr">
          <!-- <span> 注意:左边第一列日语品名栏必须填写，否则会保存失败</span> -->
          <el-button type="primary" size="small" @click="add">
            {{ $t("message.add") }}
          </el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex03">NO</li>
          <li class="flex03"> <el-checkbox v-model="checked" @change="allChecked"></el-checkbox></li>
          <!-- 商品图片 -->
          <li>{{ $t("message.productPicture") }}</li>
          <!-- 品名（中文） -->
          <li>{{ $t("message.material") }}（中文）</li>
          <!-- 品名（中文） -->
          <li>{{ $t("message.material") }}（日文）</li>
          <!-- 品名（英文） -->
          <li>{{ $t("message.material") }}（英文）</li>
          <!-- 材质 -->
          <li>{{ $t("message.texture") }}</li>
          <!-- 商品编码【ASIN】 -->
          <li class="flex15">{{ $t("message.commodityCode") }}【ASIN】</li>
          <!-- 商品数量 -->
          <li class="flex05">{{ $t("message.numberOfProducts") }}</li>
          <!-- 单价(元) -->
          <li class="flex05">{{ $t("message.unitPrice") }}(元)</li>
          <!-- 操作 -->
          <li class="flex05">{{ $t("message.operation") }}</li>
        </ol>
        <ul v-for="(item, index) in orderItems" :key="index">
          <li class="flex03">{{ index + 1 }}</li>
          <li class="flex03">
            <el-popover placement="right" title="合计" width="200" trigger="focus">
              <statistics :checkedList="checkedList" />
              <el-checkbox v-model="item.checked" @change="changeCheck" slot="reference"></el-checkbox>
            </el-popover>
          </li>
          <!-- 商品图片 -->
          <li @click="i = index">
            <el-popover placement="right" width="300" trigger="hover">
              <img :src="item.picture" alt="" style="width: 300px; height: 300px" />
              <a :href="item.saleLink" target="_blank" slot="reference">
                <img :src="item.picture" style="width: 60px" alt="" />
              </a>
            </el-popover>
            <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <i class="el-icon-edit-outline"></i>
            </el-upload>
          </li>
          <!-- 中文品名 -->
          <li>
            <el-input v-model="item.descriptionCN" size="small"
              @input="allEdit(item.descriptionCN, 'descriptionCN', item.checked)"></el-input>
          </li>
          <!-- 中文品名 -->
          <li>
            <el-input v-model="item.descriptionJP" size="small"
              @input="allEdit(item.descriptionJP, 'descriptionJP', item.checked)"></el-input>
          </li>
          <!-- 品名（英文） -->
          <li>
            <el-input v-model="item.description" size="small"
              @input="allEdit(item.description, 'description', item.checked)"></el-input>
          </li>
          <!-- 材质 -->
          <li>
            <el-input v-model="item.material" size="small"
              @input="allEdit(item.material, 'material', item.checked)"></el-input>
          </li>
          <!-- 商品编码【ASIN】 -->
          <li class="flex15 ASIN">
            <el-input v-model="item.amazonASIN" size="small"
              @input="allEdit(item.amazonASIN, 'amazonASIN', item.checked)"></el-input>
            <el-button size="small" type="primary" class="primary">
              <a :href="`https://www.amazon.co.jp/dp/${item.amazonASIN}?ref=myi_title_dp`" target="_blank"
                rel="noopener noreferrer" style="color: #fff">亚马逊链接</a>
            </el-button>
          </li>
          <!-- 商品数量 -->
          <li class="flex05 width80">
            <el-input v-model="item.quantity" size="small" type="number" @blur="totalKin"
              @input="allEdit(item.quantity, 'quantity', item.checked)"></el-input>
          </li>
          <!-- 单价-->
          <li class="flex05"> <el-input v-model="item.unitPrice" size="small" type="number" @blur="totalKin"
              @input="allEdit(item.unitPrice, 'unitPrice', item.checked, index)"></el-input>
          </li>
          <!-- 小计 -->
          <!-- 操作 -->
          <li class="flex05">
            <el-button size="mini" type="primary" class="dark" @click=deleteItem(index)>
              {{ $t("message.delete") }}
            </el-button>
          </li>
        </ul>
        <ul class="total">
          <li style="flex:3"></li>
          <li class="flex15">合计商品数：{{ total_goods_num }}</li>
          <li class="flex15">
            <div class="template">
              合计商品金额(元)：{{ total_goods_amount_rmb.toFixed(2) }}
            </div>
          </li>
          <li>
            合计国内运费(元)：
          </li>
          <li>
            <el-input v-model="details.domesticFreight" size="small"
              @input="handleInput($event, 'domesticFreight')"></el-input>
          </li>
          <li>合计增值费用(元)</li>
          <li>
            <el-input v-model="details.addedValue" size="small" @input="handleInput($event, 'addedValue')"></el-input>
            <el-popover placement="top" width="200" trigger="click"
              content="有商品正在问题产品处理中，发票增值费用，国内运费按照商品当前金额平均计算，可能与最终金额有差异，请核对！">
              <i slot="reference" class="el-icon-warning" style="font-size: 25px;color: #b4272d;cursor: pointer;"
                v-if="details.has_not_complete_problem_goods"></i>
            </el-popover>
          </li>
          <li class="flex15">
            <div class="template">
              国际运费(元)：{{ details.customerLogisticFee }}
            </div>
          </li>
          <!-- <li class="kinTotal">
           
          </li> -->
        </ul>
      </div>
    </div>
    <!-- 操作 -->
    <div class="operation">
      <!-- 同商品id -->
      <el-button type="primary" @click="productWithTheSameId" size="mini" class="fl">
        {{ $t('message.productWithTheSameId') }}
      </el-button>
      <!-- 批量删除 -->
      <el-button type="primary" @click="batchDeletion" size="mini" class="fl dark">
        {{ $t('message.batchDeletion') }}
      </el-button>
      <span style="margin-right: 20px; font-size: 16px;" v-if="details.sendDateShow">
        保存完了时间:{{ details.sendDateShow }}
      </span>

      <!-- 操作按钮 -->
      <el-button size="small" type="primary" @click="invoiceDownload" class="primary" v-if="details.sendDateShow">
        发票下载
      </el-button>
      <el-button size="small" type="primary" @click="invoiceInitialize">
        发票初始化
      </el-button>
      <el-button size="small" type="success" @click="updateLogistics" v-if="details.resolve == 2">
        修改发票
      </el-button>
      <el-button size="small" type="success" @click="cancelBOrder" v-if="details.resolve == 2">
        取消物流单号
      </el-button>
      <el-button size="small" type="primary" class="dark" @click="kilospeedRenewal" v-if="details.resolve == 1">
        临时保存
      </el-button>
      <el-button size="small" class="dark" type="primary" @click="generateLogistics" v-if="details.resolve == 1">
        生成发票
      </el-button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import statistics from './statistics'
export default {
  data() {
    return {
      radio: '1',
      dialogVisible: false,
      express_no: this.$route.query.express_no,
      type: this.$route.query.type,
      isImporter: false,
      isReceiver: false,
      total_goods_num: 0,
      total_goods_amount_rmb: 0,
      total: 0,
      shopOptions: [
        {
          key: "生成亚马逊链接",
          value: "生成亚马逊链接",
        },
      ],
      details: {},
      orderItems: [],
      i: 0,
      checked: false,
      checkedList: [],
    };
  },
  components: {
    statistics
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
    }),
  },
  created() {

    this.getPorderData();
    this.addressReminder()
  },
  methods: {
    // 千速地址变更匹配
    addressReminder() {
      let datas = {
        express_no: this.$route.query.express_no,
      };
      this.$api.invoiceApi.addressReminder(datas).then((res) => {
        if (res.data) {
          this.$alert(res.data, '浜松市地址变更', {
            dangerouslyUseHTMLString: true,
            center: true,
          });
        }
      })
    },
    getPorderData() {
      let datas = {
        express_no: this.$route.query.express_no,
      };
      this.$api.invoiceApi.getPorderData(datas).then((res) => {
       
        res.data.orderItems.forEach(item => {
          item.checked = false
        })
         this.details = res.data
        this.orderItems =this.details.orderItems
        this.totalKin()
        this.$parent.$refs.getNotice.getNotice(res.data.customerRefNo.split('-')[1], "业务注意事项", '发票')
        console.log(res);
        // this.options = res.data;
      });
    },
    // 物流方式转换
    logistics(id) {
      let name;
      this.logisticsList.forEach((item) => {
        if (item.id == id) {
          name = item.name;
        }
      });
      return name;
    },
    //添加列表商品信息
    add() {
      this.orderItems.push({
        customerBoxNo: '',
        description: '',
        descriptionCN: '',
        descriptionJP: '',
        material: '',
        picture: '',
        quantity: '',
        saleLink: '',
        unitPrice: '',
      });
    },
    //删除
    deleteItem(i) {
      this.orderItems.splice(i, 1)
      this.totalKin()
    },
    // 计算总价和小计
    totalKin() {
      this.total_goods_num = 0
      this.total_goods_amount_rmb = 0
      this.orderItems.forEach((item) => {
        this.total_goods_num += item.quantity - 0;
        item.confirm_price_rmb_item_total = (
          item.quantity * item.unitPrice
        ).toFixed(2);
        this.total_goods_amount_rmb +=
          item.confirm_price_rmb_item_total - 0;
      });
    },
    //手动获取物流号
    generateLogistics() {
      this.details.orderNo = this.express_no
      this.details.type = this.type
      let isPrice = this.orderItems.every(item => item.unitPrice != 0)
      if (!isPrice) {
        this.$confirm(
          '发票有商品单价为0，是否进行保存',
          this.$t("message.prompt"),
          {
            confirmButtonText: this.$t("message.ok"),
            cancelButtonText: this.$t("message.cancel"),
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$api.invoiceApi.generateLogistics(this.details).then(res => {
              this.$message.success(res.msg);
              this.getPorderData();
            })
          })
          .catch(() => { });
      } else {
        this.$api.invoiceApi.generateLogistics(this.details).then(res => {
          this.$message.success(res.msg);
          this.getPorderData();
        })
      }

    },
    //手动修改物流单号
    updateLogistics() {
      this.details.orderNo = this.express_no
      this.details.type = this.type
      this.$api.invoiceApi.updateLogistics(this.details).then(res => {
        this.$message.success(res.msg);
        this.getPorderData();
      })
    },
    //发票-临时保存
    kilospeedRenewal() {
      this.details.orderNo = this.express_no
      this.details.type = this.type
      this.$api.invoiceApi.kilospeedRenewal(this.details).then(res => {
        this.$message.success(res.msg);
        this.getPorderData();
      })
    },
    // 链接生成
    linkGeneration(e) {
      if (e == "生成亚马逊链接") {
        this.orderItems.forEach((item) => {
          if (item.goods_no) {
            item.fba_goods_link = `https://www.amazon.co.jp/dp/${item.goods_no}?ref=myi_title_dp`;
          }
        });
      }
      this.$message.success("已生成链接");
    },
    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      this.loading = true;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        this.loading = false;
      }
      return isJPG || isPNG;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      this.loading = false;
      if (file.code != 0) return this.$message.error(file.msg);
      this.$message.success(file.msg);
      this.orderItems[this.i].picture = file.data;
      this.$forceUpdate();
    },
    //单选
    changeCheck() {
      this.checkedList = []
      this.checked = this.orderItems.every(item => item.checked)
      this.orderItems.forEach((item) => {
        if (item.checked) {
          this.checkedList.push(item)
        }
      })
      this.$forceUpdate()
    },
    //全选
    allChecked() {
      this.checkedList = []
      this.orderItems.forEach((item) => {
        item.checked = this.checked
        this.checkedList.push(item)
      })
    },
    //批量修改
    allEdit(val, type, flag, index) {
      if (type == 'unitPrice') {
        if (!val) {
          this.orderItems[index].unitPrice = 0
          return this.$forceUpdate()
        }
        this.orderItems[index].unitPrice = this.ceil(val)
        this.$forceUpdate()
      }
      if (flag) {
        this.orderItems.forEach(item => {
          if (item.checked) {
            item[type] = val
          }
        })
      }
      this.$forceUpdate()
    },
    //取消物流单号
    cancelBOrder() {
      let datas = {
        orderNo: this.express_no
      }
      this.$api.invoiceApi.cancelBOrder(datas).then((res) => {
        this.$message.success(res.msg);
        this.getPorderData();
      });
    },
    //个人进口商信息
    copyImporter() {
      this.details.importerName = this.details.consigneeCompany ? this.details.consigneeCompany : this.details.consigneeName
      this.details.importerContactEn = this.details.consigneeAddressEn
      this.details.importerPhone = this.details.consigneeTel
      this.details.importerZipCode = this.details.consigneeZipcode
      this.details.importerContact = this.details.consigneeAddress
      this.details.importerNameEn = ''
    },
    // 同商品id
    productWithTheSameId() {
      let list = []
      this.orderItems.forEach((item) => {
        if (item.checked) {
          list.push(item)
        }
      })
      this.orderItems.forEach((item) => {
        list.forEach(items => {
          if (items.goods_id == item.goods_id) {
            item.checked = true
          }
        })
      })
      this.$forceUpdate()
    },
    // 批量删除
    batchDeletion() {
      let list = []
      this.orderItems.forEach(item => {
        if (!item.checked) {
          list.push(item)
        }
      })
      this.orderItems = JSON.parse(JSON.stringify(list))
      // 批量删除重新生成数组后同步提交数据，避免保存或生成发票时仍携带已删除商品。
      this.details.orderItems = this.orderItems
      this.totalKin()
    },
    // 发票初始化
    invoiceInitialize() {
      let datas = {
        orderNo: this.express_no
      }
      this.$api.invoiceApi.invoiceInitialize(datas).then((res) => {
        this.$message.success(res.msg);
        this.getPorderData();
      });

    },
    // 发票下载
    invoiceDownload() {
      let datas = {
        orderNo: this.express_no
      }
      this.$api.invoiceApi.invoiceDownload(datas).then((res) => {
        const a = document.createElement('a');
        const href = res.data
        a.href = href;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); // 下载完移除元素
      });
    },
    // 是否输入的小数
    handleInput(value, type) {
      this.details[type] = ("" + this.details[type]) // 第一步：转成字符串
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
    },
  },
};
</script>

<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

h6 {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
}

.invoice {
  display: flex;

  .summaryOfCurrentInvoiceInformation {
    width: 1000px;

    .information {
      width: 1000px;
      border: 2px solid #32323c;
      border-radius: 4px;

      .row {
        display: flex;
        border-bottom: 1px solid #32323c;

        &:nth-last-child(1) {
          border: 0;
        }

        .item {
          flex: 1;
          display: flex;
          height: 60px;

          .label {
            flex: 1;
            border-right: 1px solid #32323c;
            color: #333333;
          }

          .value {
            flex: 2.2;
            color: #2c96e7;
          }

          .border-right {
            border-right: 1px solid #32323c;
          }

          div {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
          }
        }
      }
    }
  }

  .senderInformation {
    width: 680px;
    margin-left: 80px;

    .information {
      border: 2px solid #2c96e7;
      border-radius: 8px;
      padding: 24px;
      height: 134px;

      .row {
        display: flex;
        line-height: 27px;

        .label {
          width: 62px;
          margin-right: 20px;
        }
      }
    }
  }
}

.address {
  display: flex;
  margin: 40px 0;

  .information {
    flex: 1;
    padding: 30px 40px;
    background: #f8f8f8;
    border-radius: 8px;

    .p {
      margin-bottom: 25px;
      font-size: 16px;
    }

    .list {
      .row {
        display: flex;

        .item {
          display: flex;
          flex: 1;
          margin-bottom: 8px;

          &:nth-child(even) {
            margin-left: 10px;
          }

          .label {
            flex: 1;
            line-height: 32px;
            text-align: right;
            margin-right: 10px;
            font-size: 14px;
          }

          .value {
            width: 240px;
          }
        }
      }
    }
  }
}

.commodity {
  padding: 30px;
  background: #f8f8f8;
  border-radius: 8px;
  // overflow: hidden;
  margin-bottom: 24px;

  .information {
    line-height: 32px;

    span {
      color: #b4272d;
      margin-right: 38px;
    }
  }

  .table {
    margin: 24px 0;
    width: 100%;

    ol {
      position: sticky;
      left: 0;
      top: 0;
      z-index: 99;
    }

    ul {
      padding: 20px 0;

      .template {
        width: 100%;
        text-align: left;
      }

      /deep/.el-input {
        width: 80%;
      }

      .Amazon {
        height: 40px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/ .el-input__inner {
          border: 0;
          background-color: #e0e7f7;
        }
      }

      .screenshot {
        .img {
          width: 80px;
          height: 48px;
          position: relative;
          border-radius: 4px;
          overflow: hidden;

          &:hover {
            .uoload {
              display: flex;
            }
          }

          .uoload {
            width: 80px;
            height: 48px;
            background-color: rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0;
            left: 0;
            display: none;
            justify-content: center;
            align-items: center;
          }
        }

        img {
          width: 80px;
          height: 48px;
        }

        p {
          text-align: center;
        }
      }
    }

    .flex03 {
      flex: 0.3;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .total {
      position: sticky;
      left: 0;
      bottom: 0;

      .flex15 {
        margin: 0 20px;
      }

      li {
        margin: 0;
      }

      .template {
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/.el-input {
          width: 160px;
        }
      }

      .kinTotal {
        font-weight: bold;
        font-size: 16px;
      }
    }

    .width240 {
      /deep/ .el-input {
        width: 240px;
      }
    }

    .width80 {
      /deep/ .el-input {
        width: 80%;
      }
    }

    .ASIN {
      border-radius: 5px;

      /deep/ .el-input {
        width: 68%;
      }

      /deep/ .el-input__inner {
        border: 0;
        background-color: #e0e7f7;
      }
    }

    /deep/.el-textarea__inner {
      padding: 5px !important;
      resize: auto;
    }
  }
}

.operation {
  padding: 16px 24px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(9, 9, 9, 0.1);
  border-radius: 8px;
  position: sticky;
  left: 0;
  bottom: 0;
  line-height: 32px;
  text-align: right;
}

.shop {
  display: flex;

  .item {
    padding: 30px 40px;
    background-color: #f8f8f8;
    border-radius: 8px;
    margin-bottom: 40px;
    flex: 1;
    display: flex;

    img {
      width: 120px;
      height: 120px;
      border: 2px solid #2c96e7;
      border-radius: 4px;
    }

    .items {
      flex: 1;

      /deep/.el-input {
        margin: 20px 0;
        width: 240px;
      }
    }

    .input {
      /deep/.el-input__inner {
        background-color: #e0e7f7;
        border: 1px solid #2c96e7;
      }
    }
  }

  .item2 {
    flex: 1;
    margin-left: 40px;
    padding: 30px 40px;
  }
}

.content {
  padding: 0 25px;

  .upload {
    display: flex;
    margin-top: 22px;

    .img {
      margin-right: 30px;

      img {
        width: 200px;
        height: 200px;
      }
    }

    .el-icon-edit-outline {
      font-size: 50px;
    }
  }
}
</style>
